import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import Link from 'gatsby-link';
import ActionLink from '../../../components/actionlink/ActionLink';
import LibshareFeatures from './features/LibshareFeatures';

import './index.scss'
var version = '1.3';
var packageId = '04t1N000001shTJ';
var prodInstallUrl = `https://login.salesforce.com/packaging/installPackage.apexp?p0=${packageId}`;
var sbxInstallUrl = `https://test.salesforce.com/packaging/installPackage.apexp?p0=${packageId}`;

class LibsharePage extends Component {
    render() {
        return (
            <div className='libshare-container'>
                <Helmet title={`Datasert - Libshare`} />

                <div className="main">
                    <Container>
                        <Row>
                            <Col className='main-left'>
                                <h2>Libshare</h2>
                                <h3>Battle tested, Open Sourced reusable modules for Salesforce</h3>
                                <p>Current Version: {version}</p>
                                <p>Read <Link to='/products/libshare/docs'>Docs</Link> or View Code in <a href='https://github.com/datasert/libshare' target='_newtable'>Github</a></p>
                                <ActionLink className='button-download-product' href={prodInstallUrl} target='_newtable'>Production</ActionLink>
                                <ActionLink className='button-download-product' href={sbxInstallUrl} target='_newtable'>Sandbox</ActionLink>
                            </Col>
                            <Col><img className='banner-image' src={require('./libshare-main.png')}/></Col>
                        </Row>
                    </Container>
                </div>

                <div className="features">
                    <h2 className='title'>Modules</h2>
                    <a name="features"></a>
                    <LibshareFeatures />
                </div>
            </div>
        );
    }
}

export default LibsharePage;


// WEBPACK FOOTER //
// ./src/pages/products/libshare/index.jsx